module.exports = __webpack_public_path__ + "img/logo.301f3285.png";